import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription } from "@/components/ui/dialog";
import { Info, TrendingUp, TrendingDown } from "lucide-react";

export function IndicatorInfoDialog({ explain, trigger }) {
  if (!explain) return null;
  return (
    <Dialog>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent data-testid="indicator-info-dialog" className="bg-[#0A0D14] border-white/10 text-[#F9FAFB] max-w-md w-[calc(100vw-1.5rem)] sm:w-full max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-display text-xl flex items-center gap-2 text-left">
            <Info size={18} className="text-[#F59E0B]" /> {explain.title}
          </DialogTitle>
          <DialogDescription className="text-sm text-[#D1D5DB] leading-relaxed text-left">{explain.what}</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 text-sm leading-relaxed">
          <div className="glass rounded-2xl p-3.5">
            <div className="text-[10px] uppercase tracking-wider text-[#6B7280] font-mono-num mb-1">Why gold traders care</div>
            <p className="text-[#D1D5DB]">{explain.why_gold}</p>
          </div>
          <div className="grid gap-2">
            <div className="rounded-xl border border-white/10 p-3 flex gap-2 items-start">
              <TrendingUp size={15} className="mt-0.5 shrink-0 text-[#9CA3AF]" />
              <p className="text-[#D1D5DB] text-xs">{explain.if_higher}</p>
            </div>
            <div className="rounded-xl border border-white/10 p-3 flex gap-2 items-start">
              <TrendingDown size={15} className="mt-0.5 shrink-0 text-[#9CA3AF]" />
              <p className="text-[#D1D5DB] text-xs">{explain.if_lower}</p>
            </div>
          </div>
          <p className="text-[11px] text-[#6B7280]">Remember: markets react to the <span className="text-[#D1D5DB]">surprise</span> — the gap between the actual figure and the consensus — not to the number itself.</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export function InfoButton({ explain, testId }) {
  return (
    <IndicatorInfoDialog explain={explain} trigger={
      <button data-testid={testId} aria-label="What is this?" onClick={(e) => e.stopPropagation()}
        className="w-6 h-6 rounded-full grid place-items-center text-[#9CA3AF] hover:text-[#F59E0B] hover:bg-white/5 transition-colors shrink-0">
        <Info size={13} />
      </button>
    } />
  );
}
